@if ({
  options: options$ | async,
  invoicesRequest: invoicesRequest$ | async,
  }; as content) {
  <div class="simple-card">
    <page-title></page-title>
  </div>
  <div class="simple-card m-t-20">
    <p class="m-b-12 h5">{{ 'invoice.form.instructions' | cxTranslate }}</p>
    <form [formGroup]="form" (submit)="submit()">
      <div class="row">
        <div class="col-12">
          <h6 class="d-block m-b-12">{{ 'formSearch.searchBy' | cxTranslate }}</h6>
          <div class="form-field-select">
            <div class="form-check form-check-inline">
              <input type="radio" id="searchByInvoiceDate" class="form-check-input" formControlName="searchBy" value="invoiceDate" />
              <label class="form-check-label" for="searchByInvoiceDate">{{ 'invoice.form.invoiceDate' | cxTranslate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input type="radio" id="searchByInvoiceNumber" class="form-check-input" formControlName="searchBy" value="invoiceNumber" />
              <label class="form-check-label" for="searchByInvoiceNumber">{{ 'formSearch.invoiceNumber' | cxTranslate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input type="radio" id="searchByPONumber" class="form-check-input" formControlName="searchBy" value="poNumber" />
              <label class="form-check-label" for="searchByPONumber">{{ 'formSearch.poNumber' | cxTranslate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input type="radio" id="searchByOrderNumber" class="form-check-input" formControlName="searchBy" value="orderNumber" />
              <label class="form-check-label" for="searchByOrderNumber">{{ 'formSearch.orderNumber' | cxTranslate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input type="radio" id="searchByCatalogNumber" class="form-check-input" formControlName="searchBy" value="catalogNumber" />
              <label class="form-check-label" for="searchByCatalogNumber">{{ 'formSearch.catalogNumber' | cxTranslate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input type="radio" id="searchByPartNumber" class="form-check-input" formControlName="searchBy" value="partNumber" />
              <label class="form-check-label" for="searchByPartNumber">{{ 'formSearch.partNumber' | cxTranslate }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                type="radio"
                id="searchByCustomerPartNumber"
                class="form-check-input"
                formControlName="searchBy"
                value="customerPartNumber"
                />
                <label class="form-check-label" for="searchByCustomerPartNumber">{{ 'formSearch.customerPartNumber' | cxTranslate }}</label>
              </div>
            </div>
          </div>
          @if (form.get('searchBy')?.value === 'invoiceDate') {
            @if (form.get('searchType')?.value !== 'custom') {
              <div class="col-12 col-md-4 m-t-16">
                <div class="form-group">
                  <span>{{ 'formSearch.selectDateRange' | cxTranslate }}</span>
                  <select class="form-control" formControlName="searchType">
                    <option value="" disabled selected>{{ 'formSearch.selectOption' | cxTranslate }}</option>
                    @for (item of content.options; track item) {
                      <option [value]="item.code">
                        {{ item.label }}
                      </option>
                    }
                  </select>
                  <cx-form-errors [control]="form.get('searchType')"></cx-form-errors>
                </div>
              </div>
            } @else {
              <div class="col-12 col-md-4 m-t-16">
                <div class="form-group w custom-date-picker">
                  <div class="d-flex v-center m-b-4">
                    <button type="button" class="btn-back-search-type" (click)="backSearchType()">
                      <span class="material-symbols-outlined d-flex"> arrow_back_ios </span>
                    </button>
                    <label class="m-0" for="fromDate">{{ 'formSearch.from' | cxTranslate }}</label>
                  </div>
                  <p-datepicker
                    formControlName="fromDate"
                    dateFormat="mm/dd/yy"
                    showIcon="true"
                    inputStyleClass="form-control"
                    placeholder="..."
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    allowedKeysToDatePicker
                  ></p-datepicker>
                  <cx-form-errors [control]="form.get('fromDate')"></cx-form-errors>
                </div>
              </div>
              <div class="col-12 col-md-4 m-t-16">
                <div class="form-group custom-date-picker">
                  <label for="toDate">{{ 'formSearch.to' | cxTranslate }}</label>
                  <p-datepicker
                    formControlName="toDate"
                    dateFormat="mm/dd/yy"
                    showIcon="true"
                    inputStyleClass="form-control"
                    placeholder="..."
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    allowedKeysToDatePicker
                  ></p-datepicker>
                  <cx-form-errors [control]="form.get('toDate')"></cx-form-errors>
                </div>
              </div>
            }
          }
          @if (form.get('searchBy')?.value !== 'invoiceDate') {
            <div class="col-12 col-md-4 m-t-16">
              <div class="form-group">
                <span>{{ 'formSearch.enterValue' | cxTranslate }}</span>
                <input
                  type="text"
                  class="form-control"
                  formControlName="searchValue"
                  placeholder="{{ 'formSearch.valuesInclude' | cxTranslate }}"
                  (keydown.enter)="onEnter($event)"
                  />
                </div>
              </div>
            }
            <div class="col-12">
              <div class="form-check m-0">
                <label>
                  <input type="checkbox" formControlName="openOnly" />
                  <span class="form-check-label">{{ 'invoice.form.showOnlyOpenInvoices' | cxTranslate }}</span>
                </label>
              </div>
            </div>
            <div class="w-100 col-12 form-button-container p-l-0">
              <div class="col-12 col-md-8 form-note">
                <span>{{ 'formSearch.note' | cxTranslate }}</span>
              </div>
              <div class="col-md-2 d-flex form-button">
                <button class="btn btn-outline-primary btn-sm w-100" (click)="clearAll()">
                  {{ 'formSearch.clearAll' | cxTranslate }}
                </button>
              </div>
              <div class="col-md-2 d-flex form-button">
                <button type="submit" class="btn btn-primary btn-sm w-100">
                  <span class="material-symbols-outlined d-flex m-r-4"> search </span>
                  {{ 'formSearch.search' | cxTranslate }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      @if (!content.invoicesRequest?.isPristine) {
        <div class="simple-card m-t-20">
          @if (!content.invoicesRequest?.isLoading) {
            @if (content.invoicesRequest?.invoices?.length) {
              <table-pro [configs]="tableConfig">
                <div top-action-2>
                  <button type="button" class="btn btn-secondary btn-sm w-100" (click)="exportInvoices()">
                    <span class="material-symbols-outlined d-flex m-r-4"> download </span>
                    {{ 'exportEntries.exportToExcel' | cxTranslate }}
                  </button>
                </div>
                <table class="table-responsive table-md">
                  <thead>
                    <tr>
                      <th>{{ 'invoice.table.header.invoiceNumber' | cxTranslate }}</th>
                      <th>{{ 'invoice.table.header.invoiceDate' | cxTranslate }}</th>
                      <th>{{ 'invoice.table.header.grossAmount' | cxTranslate }}</th>
                      <th>{{ 'invoice.table.header.amountOwed' | cxTranslate }}</th>
                      <th>{{ 'invoice.table.header.poNumber' | cxTranslate }}</th>
                      <th>{{ 'invoice.table.header.dueDate' | cxTranslate }}</th>
                      <th>{{ 'invoice.table.header.paymentTerm' | cxTranslate }}</th>
                      <th>{{ 'invoice.table.header.status' | cxTranslate }}</th>
                      <th>{{ 'invoice.table.header.creditAdj' | cxTranslate }}</th>
                      <th>{{ 'invoice.table.header.orderNumber' | cxTranslate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (invoice of content.invoicesRequest?.invoices; track invoice) {
                      <tr>
                        <td [attr.data-value]="invoice.invoiceNumber">
                          <div class="d-flex">
                            <span class="responsive-title m-r-4"> {{ 'invoice.table.header.invoiceNumber' | cxTranslate }}:</span>
                            <a [routerLink]="['/my-account/invoice', invoice.invoiceUid]" class="text-underline">{{ invoice.invoiceNumber }}</a>
                          </div>
                        </td>
                        <td [attr.data-value]="invoice.invoiceDate">
                          <span class="responsive-title"> {{ 'invoice.table.header.invoiceDate' | cxTranslate }}:</span>
                          {{ invoice.invoiceDate }}
                        </td>
                        <td [attr.data-value]="invoice.grossAmount?.value">
                          <span class="responsive-title"> {{ 'invoice.table.header.grossAmount' | cxTranslate }}:</span>
                          {{ invoice.grossAmount?.formattedValue }}
                        </td>
                        <td [attr.data-value]="invoice.amountOwed?.value">
                          <span class="responsive-title"> {{ 'invoice.table.header.amountOwed' | cxTranslate }}:</span>
                          {{ invoice.amountOwed?.formattedValue }}
                        </td>
                        <td [attr.data-value]="invoice.poNumber">
                          <span class="responsive-title"> {{ 'invoice.table.header.poNumber' | cxTranslate }}:</span>
                          {{ invoice.poNumber }}
                        </td>
                        <td [attr.data-value]="invoice.dueDate">
                          <span class="responsive-title"> {{ 'invoice.table.header.dueDate' | cxTranslate }}:</span>
                          {{ invoice.dueDate }}
                        </td>
                        <td [attr.data-value]="invoice.paymentTerm">
                          <span class="responsive-title"> {{ 'invoice.table.header.paymentTerm' | cxTranslate }}:</span>
                          {{ invoice.paymentTerm }}
                        </td>
                        <td [attr.data-value]="invoice.status">
                          <span class="responsive-title"> {{ 'invoice.table.header.status' | cxTranslate }}:</span>
                          {{ invoice.status }}
                        </td>
                        <td [attr.data-value]="invoice.creditAdj?.value">
                          <span class="responsive-title"> {{ 'invoice.table.header.creditAdj' | cxTranslate }}:</span>
                          {{ invoice.creditAdj?.formattedValue }}
                        </td>
                        <td [attr.data-value]="invoice.orderNumber">
                          <span class="responsive-title"> {{ 'invoice.table.header.orderNumber' | cxTranslate }}:</span>
                          {{ invoice.orderNumber }}
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </table-pro>
            } @else {
              <p class="text-center ff-bold m-0">{{ 'invoice.noInvoicesAvailable' | cxTranslate }}</p>
            }
          } @else {
            <local-loader></local-loader>
          }
        </div>
      }
    }
